import { render } from "./SmallLoader.vue?vue&type=template&id=292778e4"
import script from "./SmallLoader.vue?vue&type=script&lang=js"
export * from "./SmallLoader.vue?vue&type=script&lang=js"

import "./SmallLoader.vue?vue&type=style&index=0&id=292778e4&lang=scss"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__